import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';
import { fetchPost } from '../../store/fetch';
import { Roles } from '../../utils/enums/Roles';
import { isCustomerVersion } from '../../utils/isCustomerVersion';
import { Modal } from '../common/Modal/Modal';
import { EditPanelButton, PanelButtonLink } from '../elements';
import { Spinner } from '../spinners';
import { useUserHasRole } from '../utils/authorization/useUserHasRole';

export function CompanyMaintenanceCopy(props: { clientCompanyId: string }) {
    const { userHasRole } = useUserHasRole();
    const isAdmin = userHasRole([Roles.Administrator]);
    const translate = useTranslate();
    const [isCopyMaintenanceDialogVisible, setIsCopyMaintenanceDialogVisible] = React.useState(false);

    return (
        <>
            {isAdmin && isCustomerVersion('zxy') && (
                <PanelButtonLink
                    text={translate('survey.importDefaultMaintenance')}
                    onClick={() => setIsCopyMaintenanceDialogVisible(true)}
                    icon="fa fa-cogs"
                    small
                    mt
                />
            )}
            {isCopyMaintenanceDialogVisible && (
                <CopyMaintenanceDialog clientCompanyId={props.clientCompanyId} onClose={() => setIsCopyMaintenanceDialogVisible(false)} />
            )}
        </>
    );
}

function CopyMaintenanceDialog(props: { clientCompanyId: string; onClose: () => void }) {
    const [isLoading, setIsLoading] = React.useState(false);
    const [maintenanceCopyCounter, setMaintenanceCopyCounter] = React.useState<undefined | number>(undefined);
    const handleCloseFormClicked = () => {
        props.onClose();
    };

    const copyMaintenance = async () => {
        setIsLoading(true);
        const result = await fetchPost(`/api/defaultMaintenanceMeasures/copy/${props.clientCompanyId}`);
        setMaintenanceCopyCounter(result.json.count);
        setIsLoading(false);
    };

    return (
        <Modal id="copy-dialog" classNames="confirm-dialog" closeOnBackdropClick={true} onClose={() => handleCloseFormClicked()}>
            <Modal.Title>
                <h3>
                    <span className="panel-title">Copy default maintenance measures</span>
                </h3>
            </Modal.Title>
            <Modal.Content isScrollBarVisible={true} style={{ height: '150px' }}>
                {maintenanceCopyCounter === undefined && (
                    <div>
                        This operation copies all general standard measures to the client company. These can then be adjusted by the client. Measures
                        that are already in place are not copied again. This involves looking at the description of the measure to see whether it is
                        already present. <br /> <br />
                        <strong>Note: This operation cannot be undone.</strong>
                    </div>
                )}
                {maintenanceCopyCounter === 0 && <div>No measures have been found to copy.</div>}
                {maintenanceCopyCounter !== undefined && maintenanceCopyCounter > 0 && (
                    <div>Copy finished. Number of measures copied: {maintenanceCopyCounter}</div>
                )}
                {isLoading && (
                    <div>
                        <Spinner />
                    </div>
                )}
            </Modal.Content>
            <Modal.Actions>
                <EditPanelButton small={true} text="Cancel" onClick={() => handleCloseFormClicked()} />
                <EditPanelButton small={true} disabled={isLoading} text="Start copying measures" onClick={async () => copyMaintenance()} danger />
            </Modal.Actions>
        </Modal>
    );
}
